import React, { useState } from 'react'
import Popover from '@mui/material/Popover';
import Paper from '@mui/material/Paper';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux'
import { useMediaQuery } from '@mui/material'

import { MOBILE_QUERY } from '../layout/mobile-shell'

import { removeToken, resetIdentity, resolveAttachmentUrl } from '../../core'
import { SettingsIcon, LogoutIcon } from '../icons';
import {
  UserAvatar,
  UserInfo,
  UserTitle,
  UserSubTitle,
  UserWrapper,
  UserMenuItem
 } from './styled'
import {useTranslation} from "react-i18next";

const UserBlock = ({ currentUser }) => {
  const navigate = useNavigate()
  const { t } = useTranslation();
  // Роль в выбранном парке из capabilities: user_type у всех сотрудников
  // парка одинаковый (operator) и роль не отличает
  const roleName = useSelector(state => state.capabilities.role?.name)

  const [anchorEl, setAnchorEl] = useState(null);
  // На телефоне блок стоит вверху экрана «Главная», и меню открывается вниз
  const isMobile = useMediaQuery(MOBILE_QUERY)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () => {
    removeToken();
    resetIdentity();
    navigate('/');
  };

  if (!currentUser) {
    return null;
  }

  const hasName = currentUser.first_name && currentUser.last_name;
  const avatarText = hasName
    ? `${currentUser.first_name[0]}${currentUser.last_name[0]}`
    : currentUser.email[0];
  const displayName = hasName
    ? `${currentUser.first_name} ${currentUser.last_name}`
    : currentUser.email;

  return (
    <>
      <UserWrapper onClick={handleClick}>
        <UserAvatar>
          {currentUser.avatar?.url
            ? <img src={resolveAttachmentUrl(currentUser.avatar.url)} alt="" />
            : avatarText}
        </UserAvatar>
        <UserInfo>
          <UserTitle title={displayName}>{displayName}</UserTitle>
          <UserSubTitle>{roleName || (currentUser?.user_type ? t(`userBlock.roles.${currentUser.user_type}`) : 'B2B client')}</UserSubTitle>
        </UserInfo>
      </UserWrapper>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        style={isMobile ? undefined : { transform: 'translate(-40px, -50px)' }}
        anchorOrigin={{
          vertical: isMobile ? 'bottom' : 'top',
          horizontal: 'center',
        }}
      >
        <Paper style={{ padding: 8, minWidth: 200 }} elevation={3}>
          <UserMenuItem
              onClick={() => {
                handleClose()
                navigate('/settings')
              }}
          >
            <SettingsIcon />
            {t('userBlock.settings')}
          </UserMenuItem>
          <UserMenuItem onClick={logout} color="red">
            <LogoutIcon />
            {t('userBlock.logout')}
          </UserMenuItem>
        </Paper>
      </Popover>
    </>
  );
};

export default UserBlock;
